import React, { useEffect, useRef, useState } from "react";
import { Modal, Form, Input, Switch, message } from "antd";
import {
  addPharmacyConfigApi,
  updatePharmacyConfigApi,
} from "../../../services/pharmacyConfigs.services";
import { SIMPLE_CONFIG_TYPES } from "./configTypes";
import { nameRules, shortCodeRules } from "../common/validators";

const FIELD_LABELS = {
  name: "Name",
  short_code: "Short Code",
};

const SimpleConfigFormModal = ({ resource, open, setOpen, editData, refreshPage }) => {
  const { label, fields } = SIMPLE_CONFIG_TYPES[resource];
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData) {
      form.setFieldsValue(editData);
    } else {
      form.resetFields();
    }
  }, [editData]);

  const closeAndReset = () => {
    form.resetFields();
    setOpen(false);
  };

  const onFinish = (values) => {
    setLoading(true);
    const apiCall = editData?.id
      ? updatePharmacyConfigApi(resource, editData.id, values)
      : addPharmacyConfigApi(resource, values);

    apiCall
      .then(() => {
        message.success(`${label} ${editData?.id ? "updated" : "added"} successfully`);
        setLoading(false);
        closeAndReset();
        refreshPage();
      })
      .catch((err) => {
        message.error(err?.response?.data?.message || `Failed to save ${label}`);
        setLoading(false);
      });
  };

  return (
    <Modal
      title={editData?.id ? `Edit ${label}` : `Add ${label}`}
      open={open}
      onCancel={closeAndReset}
      centered
      width={480}
      destroyOnClose
      okText="Save"
      confirmLoading={loading}
      onOk={() => formRef.current?.submit()}
    >
      <Form layout="vertical" form={form} ref={formRef} onFinish={onFinish}>
        {fields.map((field) => (
          <Form.Item
            key={field}
            label={FIELD_LABELS[field]}
            name={field}
            rules={
              field === "name"
                ? nameRules(label)
                : field === "short_code"
                ? shortCodeRules
                : []
            }
          >
            <Input placeholder={FIELD_LABELS[field]} />
          </Form.Item>
        ))}
        <Form.Item
          label="Active"
          name="is_active"
          valuePropName="checked"
          initialValue
        >
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SimpleConfigFormModal;
